<template src='./generate-orders.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import i18n from '@/i18n'
import { VMoney } from 'v-money'
import { EventBus } from '@/router/bus'
import { mask } from 'vue-the-mask'
import Moment from 'moment'
import { isNumber } from 'lodash'

export default {
  components: { ContextPage },
  directives: {
    mask,
    money: VMoney
  },
  data () {
    return {
      loading: false,
      money: {
        decimal: ',',
        thousands: ' ',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      },
      orders: [],
      orderSum: 0,
      paymentOrder: {
        orderNumber: null,
        groupPaymentOrder: false,
        paymentOrders: []
      },
      processedPaymentOrders: null,
      groupOrder: false,
      dialog: false,
      editedIndex: -1,
      editedItem: {
        paymentOrders: 0
      },
      defaultItem: {
        paymentOrders: 0
      },
      subsidyTypes: [
        { value: 100, text: 'СВИ' },
        { value: 1, text: i18n.t('userTypes.' + 1) },
        { value: 2, text: i18n.t('userTypes.' + 2) },
        { value: 3, text: i18n.t('userTypes.' + 3) },
        { value: 4, text: i18n.t('userTypes.' + 4) },
        { value: 5, text: i18n.t('userTypes.' + 5) },
        { value: 6, text: i18n.t('userTypes.' + 6) }
      ],
      selectedType: 100,
      headers: [
        {
          text: i18n.t('subsidyUser.bank'),
          align: 'start',
          sortable: false,
          value: 'bank'
        },
        {
          text: i18n.t('subsidyUser.requestedOrders'),
          align: 'start',
          sortable: false,
          value: 'paymentOrders'
        },
        {
          text: i18n.t('subsidyUser.availableOrders'),
          align: 'start',
          sortable: false,
          value: 'availableOrders'
        },
        { text: '', value: 'actions', sortable: false },
        { text: '', value: 'download', sortable: false }
      ],
      orderNumberMask: '##'
    }
  },
  methods: {
    retrieveAvailableOrders () {
      this.loading = true
      this.orders = []
      this.paymentOrder.paymentOrders = []
      this.processedPaymentOrders = null
      this.orderSum = 0
      // add api get request to roles and groups, localRoles and groups are muck for now
      this.$http.get(Vue.$apiConfig.availableOrdersGet, { params: { subsidyType: this.selectedType } }).then(
        response => {
          this.logConsole(response)
          this.formatPaymentOrders(response.data.payload)
          this.loading = false
        },
        error => {
          this.formatErrorResponse(error)
          this.logConsole(error)
          this.loading = false
        }
      )
    },
    validateBeforeSubmit () {
      for (var i = 0; i < this.orders.length; i++) {
        if (Number(this.orders[i].paymentOrders.toString().replace(/\s/g, '')) > Number(this.orders[i].availableOrders.toString().replace(/\s/g, ''))) {
          EventBus.$emit('alert', {
            variant: 'error',
            message: i18n.t('subsidyUser.requestOrderError')
          })
          return
        }
      }
      this.submitPaymentOrder()
    },
    submitPaymentOrder () {
      this.loading = true
      this.paymentOrder.paymentOrders = []
      this.processedPaymentOrders = null
      this.paymentOrder.subsidyType = this.selectedType
      for (var i = 0; i < this.orders.length; i++) {
        if (isNumber(this.orders[i].paymentOrders) && this.orders[i].paymentOrders > 0) {
          this.paymentOrder.paymentOrders.push({
            bank: this.orders[i].bankCode,
            numberOfOrders: this.orders[i].paymentOrders
          })
        } else {
          const paymentOrderValue = Number(this.orders[i].paymentOrders.toString().replace(/\s/g, ''))
          if (paymentOrderValue > 0) {
            this.paymentOrder.paymentOrders.push({
              bank: this.orders[i].bankCode,
              numberOfOrders: paymentOrderValue
            })
          }
        }
      }
      if (this.paymentOrder.paymentOrders.length === 0) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: i18n.t('subsidyUser.requestOrderError')
        })
        this.loading = false
        return
      }
      this.$http.post(Vue.$apiConfig.processOrdersPost, this.paymentOrder).then(
        response => {
          this.loading = false
          this.processedPaymentOrders = response.data.payload
        },
        error => {
          this.formatErrorResponse(error)
          this.logConsole(error)
          this.loading = false
        }
      )
    },
    formatPaymentOrders (data) {
      for (var i = 0; i < data.length; i++) {
        this.orderSum += Number(data[i].availableOrders)
        this.orders.push({
          bankCode: data[i].bank,
          bank: this.getBankName(data[i].bank),
          paymentOrders: 0,
          availableOrders: Number(data[i].availableOrders)
        })
      }
    },
    isInvalidOrder (item) {
      if (isNumber(item.availableOrders) && isNumber(item.paymentOrders)) {
        if (item.paymentOrders > item.availableOrders) {
          return true
        }
        return false
      } else {
        if (Number(item.paymentOrders.replaceAll(' ', '')) > Number(item.availableOrders.replaceAll(' ', ''))) {
          return true
        }
        return false
      }
    },
    downloadCSVData (bank) {
      let csv = 'DatumSlanja,RedniBroj,JMBG,BrLicneKarte,NazivKorisnika,Banka,Partija,KB,Iznos,Status\r\n'
      this.processedPaymentOrders.forEach((row) => {
        if (bank === row.bank) {
          csv += row.paymentOrderDate + ','
          csv += row.paymentOrderNumber + ','
          csv += row.uniqueIdentificationNumber + ','
          csv += row.identificationNumber + ','
          csv += row.name + ','
          csv += row.bank + ','
          csv += row.account + ','
          csv += row.controlNumber + ','
          csv += row.subsidyAmount + ','
          csv += row.status
          csv += '\r\n'
        }
      })

      const anchor = document.createElement('a')
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
      anchor.target = '_blank'
      anchor.download = bank + '_odUT_' + Moment().format('YYYYMMDD') + '_' + this.paymentOrder.orderNumber + '.csv'
      anchor.click()
    },
    downloadXMLData (data) {
      let xml = '<?xml version="1.0" encoding="utf-8" standalone="yes"?>\r\n'
      xml += '<COVID-19>\r\n'
      xml += '\t<Zaglavlje>\r\n'
      xml += '\t\t<DatumSlanja>' + Moment().format('DD.MM.YYYY') + '</DatumSlanja>\r\n'
      xml += '\t\t<RedniBroj>' + this.paymentOrder.orderNumber + '</RedniBroj>\r\n'
      xml += '\t</Zaglavlje>\r\n'
      data.forEach((row) => {
        xml += '\t<PrivatniS>\r\n'
        xml += '\t\t<BrLicneKarte>' + row.identificationNumber + '</BrLicneKarte>\r\n'
        xml += '\t\t<NazivKorisnika>' + row.name + '</NazivKorisnika>\r\n'
        xml += '\t\t<Banka>' + row.bank + '</Banka>\r\n'
        xml += '\t\t<Partija>' + row.account + '</Partija>\r\n'
        xml += '\t\t<KB>' + row.controlNumber + '</KB>\r\n'
        xml += '\t\t<Iznos>' + row.subsidyAmount + '</Iznos>\r\n'
        xml += '\t</PrivatniS>\r\n'
      })
      xml += '</COVID-19>\r\n'

      const anchor = document.createElement('a')
      anchor.href = 'data:text/xml;charset=utf-8,' + encodeURIComponent(xml)
      anchor.target = '_blank'
      if (Vue.$config.service_name.toUpperCase() === 'PMI') {
        anchor.download = 'IMUN_' + Moment().format('YYYYMMDD') + '_' + this.paymentOrder.orderNumber + '.xml'
      } else {
        anchor.download = 'GRA_' + Moment().format('YYYYMMDD') + '_' + this.paymentOrder.orderNumber + '.xml'
      }
      anchor.click()
    }
  }
}
</script>
<style>

.theme--light.v-data-table thead tr th {
  font-size: 16px !important;
}

.v-data-table td {
  font-size: 16px !important;
}

.theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
.theme--light.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row),
.theme--light.v-data-table tbody tr:not(:last-child) th:last-child,
.theme--light.v-data-table tbody tr:not(:last-child) th:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0,0,0,.25) !important;
}

</style>
